export interface DefaultEnvironment {
	environmentName: string;
	apiSuffix: string;
	trovataApi: string;
	beta: boolean;
	production: boolean;
	development: boolean;
	testing: boolean;
	productionToggles: boolean;
	stripe?: string;
	stripePublishableKey?: string;
	plaidRedirectUri: string;
	oauthRedirectUri: string;
	wfPartnerId: string;
	wfKeepAliveUrl: string;
	wfWidgetHost: string;
	wfLoginUrl: string;
}

export const DEFAULT_ENVIRONMENT_CONFIG: DefaultEnvironment = {
	environmentName: 'local',
	apiSuffix: '',
	production: false,
	beta: false,
	development: false,
	testing: false,
	productionToggles: false,
	trovataApi: 'https://widget-api-dev.trovata.io',
	// plaidRedirectUri: 'http://localhost:4200/plaid-oauth', // use this url when plaid is in sandbox mode
	plaidRedirectUri: 'https://app.trovata.io/plaid-oauth',
	oauthRedirectUri: 'https://app.trovata.io/home/connections/success',
	wfPartnerId: 'a150815c-3a7e-4a0f-828c-1e32fcb688bf',
	wfKeepAliveUrl: 'https://wellsceopauat.ceo.wellsfargo.com/ceoportal/sessionKeepAlive.html',
	wfWidgetHost: 'wfuat-multibank.trvta.com',
	wfLoginUrl: 'https://wellsofficeuat.ceo.wellsfargo.com/portal/signon/index.jsp',
};
